import { render, staticRenderFns } from "./UserTopUpModal.vue?vue&type=template&id=5ebde75a"
import script from "./UserTopUpModal.vue?vue&type=script&lang=js"
export * from "./UserTopUpModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports